<template>
<div id="transferManage">
  <div class="search">
    <div class="tabTit">
      <ul>
        <li :class="curMenu === '1' ?'cur':''" @click="setCurMenu('1')">当前任务</li>
        <li :class="curMenu === '0' ?'cur':''" @click="setCurMenu('0')">历史任务</li>
      </ul>
      <div class="clearFix"></div>
    </div>
  </div>
  <br/>
  <div class="search" style="width:100%;height:100%;" v-if="curMenu === '1'">
    <div class="titleRw">
      <div class="searchInline">
        <p>共计:{{titleLength}}个、分别是：</p><br/>
        <p v-for="(item, index) in titleData" :key="index">{{item.taskName}}{{item.taskNums}}个、</p>
        <br/>
      </div>
      <el-button class="btn" type="primary" @click="goHuJiao">去呼叫</el-button>
    </div>
  </div>
  <div class="contentView">
    <!-- 当前任务 -->
    <el-table :data="tableData" key="dangqian" v-if="curMenu === '1'" style="width: 100%;">
      <el-table-column
        prop="userName"
        label="客户姓名"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="taskPhone"
        label="手机号"
        min-width="100">
      </el-table-column>
      <!-- 0 双签 1 注册 -->
      <el-table-column
        label="类型"
        min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.userSource == 0">双签用户</span>
          <span v-if="scope.row.userSource == 1">注册用户</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="taskDetailName"
        label="所属任务"
        min-width="100">
      </el-table-column>
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openUserDetail(scope.row)">用户详情</span>
          <span class="to_able" @click="goHuJiao">呼叫</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 历史任务 -->
    <el-table :data="tableData1" key="lishi" v-if="curMenu === '0'" style="width: 100%;">
      <el-table-column
        prop="taskDetailName"
        label="任务名称"
        min-width="100">
      </el-table-column>
      <el-table-column
        label="客户类型"
        prop="userSource"
        min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.userSource == 0">双签用户</span>
          <span v-if="scope.row.userSource == 1">注册用户</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="callNums"
        label="已呼叫数量"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="clientNum"
        label="客户数量"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="connectNum"
        label="接通数量"
        min-width="100">
      </el-table-column>
      <el-table-column
        prop="creatAt"
        label="创建时间"
        min-width="100">
      </el-table-column>
      <el-table-column
        class="tableOptions"
        label="操作"
        min-width="120">
        <template slot-scope="scope">
          <span class="to_able" @click="openSubmit(scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="curMenu === '0'">
      <el-pagination
        @size-change="sizeChange1"
        @current-change="handleCurrentChange1"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult1">
      </el-pagination>
    </div>
    <div class="pagination" v-else>
      <el-pagination
        @size-change="sizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10,20,30,40]"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalResult">
      </el-pagination>
    </div>
  </div>
</div>
</template>

<script>
import { devCode } from '@/http/baseUrl';
export default {
  name: 'transferManage',
  data () {
    return {
      curMenu: this.$route.query.curMenu || '1',
      searchParams: {
        mobile: '',
        Name: '',
        isAccount: '',
        time: [],
        ffTime: [],
        pageSize: 10,
        pageIndex: 0
      },
      ids: '',
      titleData: [],
      tableData: [],
      tableData1: [],
      titleLength: '',
      currentPage: 1,
      totalResult: 0,
      totalResult1: 0,
      totalPage: 0,
      dialog: {
        submit: {
          show: false,
          userName: '',
          manageId: '',
          batchNo: ''
        }
      }
    };
  },
  created () {
    this.getManager();
    // 第一次进页面不请求历史任务接口，从历史任务详情页返回上一级时请求
    if (this.$route.query.curMenu === '0') {
      console.log('999999999');
      this.getManagerHistory();
    }
  },
  methods: {
    // 获取manageID   当前任务
    getManager () {
      this.axios.get('/doubleTask/getManagerId' + devCode, {
        params: {
        }
      }).then(res => {
        console.log(res, '99');
        if (res.data.isSuccess) {
          this.axios.get('/doubleTask/CurrTaskStatics' + devCode, {
            params: {
              managerId: res.data.resultData.managerId
            }
          }).then(res => {
            console.log(res, '88');
            if (res.data.isSuccess) {
              this.titleData = res.data.resultData.taskDetailStaisticsList;
              this.titleLength = res.data.resultData.taskDetailStaisticsList.length;
            } else {
              this.$message.error(res.data.message);
            }
          });
          // 哈哈
          this.axios.get('/doubleTask/CurrTaskDetail' + devCode, {
            params: {
              managerId: res.data.resultData.managerId,
              pageIndex: this.searchParams.pageIndex,
              pageSize: this.searchParams.pageSize
            }
          }).then(res => {
            console.log(res, '99');
            if (res.data.isSuccess) {
              this.tableData = res.data.resultData.pageListData;
              this.totalResult = res.data.resultData.totalResult;
              this.totalPage = res.data.resultData.totalPage;
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 获取manageID   历史任务
    getManagerHistory () {
      this.axios.get('/doubleTask/getManagerId' + devCode, {
        params: {
        }
      }).then(res => {
        console.log(res, '99');
        if (res.data.isSuccess) {
          this.axios.get('/doubleTask/CurrTaskDetail' + devCode, {
            params: {
              checkType: this.curMenu,
              managerId: res.data.resultData.managerId,
              pageIndex: this.searchParams.pageIndex,
              pageSize: this.searchParams.pageSize
            }
          }).then(rese => {
            console.log(rese);
            if (rese.data.isSuccess) {
              this.tableData1 = rese.data.resultData.pageListData;
              this.totalResult1 = rese.data.resultData.totalResult;
              this.totalPage = rese.data.resultData.totalPage;
            } else {
              this.$message.error(rese.data.message);
            }
          });
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 搜索列表
    goHuJiao () {
      // 去逸创后台呼叫
      window.open('https://youtuchefu.kf5.com/agent/#/calls/my-tasks/list', '_blank');
    },
    // 切换标签页
    setCurMenu (num) {
      console.log(num);
      this.tableData = [];
      this.tableData1 = [];
      if (num === '1') {
        this.curMenu = '1';
        this.getManager(); // 当前任务
      } else {
        this.curMenu = '0';
        this.getManagerHistory(); // 历史任务
      }
      this.totalResult = 0;
      this.totalResult1 = 0;
    },
    // 更改pageSize
    sizeChange (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      if (this.curMenu === '1') {
        this.getManager(); // 当前任务
      } else {
        this.getManagerHistory(); // 历史任务
      }
      // this.getManager();
      // this.getManagerHistory();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange (val) {
      this.searchParams.pageIndex = val - 1;
      if (this.curMenu === '1') {
        this.getManager(); // 当前任务
      } else {
        this.getManagerHistory(); // 历史任务
      }
    },
    // 更改pageSize
    sizeChange1 (val) {
      this.searchParams.pageSize = val;
      this.searchParams.pageIndex = 0;
      if (this.curMenu === '1') {
        this.getManager(); // 当前任务
      } else {
        this.getManagerHistory(); // 历史任务
      }
      // this.getManager();
      // this.getManagerHistory();
      this.currentPage = 1;
    },
    // 跳页
    handleCurrentChange1 (val) {
      this.searchParams.pageIndex = val - 1;
      if (this.curMenu === '1') {
        this.getManager(); // 当前任务
      } else {
        this.getManagerHistory(); // 历史任务
      }
    },
    // 去详情页
    openSubmit (obj) {
      console.log(obj);
      this.$router.push({
        name: 'taskDetail',
        query: {
          taskId: obj.taskId,
          amountService: obj.amountService,
          connectNum: obj.connectNum,
          callNums: obj.callNums,
          type: 'myTask'
        }
      });
    },
    openUserDetail (obj) {
      this.$router.push({
        name: 'customerCheck',
        query: { mobile: obj.taskPhone }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tabTit {
  background: #fff;
  border-bottom: solid 2px #efefef;
  margin-bottom: 20px;
}
.tabTit li {
  float: left;
  line-height: 30px;
  font-size: 14px;
  padding: 0 10px;
  cursor: pointer;
  position: relative;
}
.tabTit li.cur {
  color: #409eff;
  font-weight: bold;
}
.tabTit li.cur:before {
  display: block;
  width: 100%;
  left: 0;
  bottom: -2px;
  content: ' ';
  height: 2px;
  background:#409eff;
  position: absolute;
}
.titleRw{
  width: 100%;
  background: #f4f4f4;
  padding: 20px 30px;
  display:flex;
  justify-content: space-between;
}
.titleRw .searchInline{
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
}
.titleRw .searchInline p{
  margin-left: 15px;
  margin-top: 10px;
}
.titleRw .searchInline p:first-child{
  font-weight:bold;
}
.btn{
  width: 62px;
  height: 40px;
}
.el-table th div.renderHeader{
  line-height: 14px; padding: 0; margin-top: 4px;
  span{margin-right: 5px;}
  i{cursor: pointer;}
}
</style>



// WEBPACK FOOTER //
// src/components/taskManage/myTask.vue